import { mediaQueriesBP } from "@dillon/Utilities/variables";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface ProductDetailsStickyContainerStyles {
    gridContainer?: InjectableCss;
}

export const StickyContainerStyles: ProductDetailsStickyContainerStyles = {
    gridContainer: {
        css: css`
            ${mediaQueriesBP.minMD} {
                width: 100%;
                top: 60px;
                position: sticky;
            }
        `,
    },
};

const styles = StickyContainerStyles;

const ProductDetailsStickyContainer: React.FC<Props> = (props: Props) => {
    const { id } = props;

    return (
        <StyledWrapper {...styles.gridContainer}>
            <Zone contentId={id} zoneName={`Content_${id}`} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ProductDetailsStickyContainer,
    definition: {
        displayName: "Product Sticky Container",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
